import { eventBus, EnumEventBus } from "../EventBus";
import BaseAngleManager from "../../../../../../src/managers/BaseAngleManager";
import { Coord } from "../../../../../../src/types/Interface";
import calcAngle from "../../../../../../src/utils/math/calcAngle";
import { anglePropsArr, generateAnglePoints } from "./helpers/drawHelpers";


export default class AngleManager extends BaseAngleManager {
  private cCoord: Coord;
  private Triangle1Mode: boolean = false;
  private Triangle2Mode: boolean = false;

  constructor(cCoord: Coord) {
    super(anglePropsArr, false)
    this.cCoord = cCoord;
    this.checkVisibles();
    eventBus.on(EnumEventBus.KiteMode, (v: boolean) => v ? this.setAllVisible(false) : this.checkVisibles());
    eventBus.on(EnumEventBus.Triangle1Mode, (v: boolean) => this.handleTriangleMode1(v));
    eventBus.on(EnumEventBus.Triangle2Mode, (v: boolean) => this.handleTriangleMode2(v));

    this.rootEventBus.on(this.EnumRootEventBus.startedCircleAnim, () => this.setVisible(false));
    this.rootEventBus.on(this.EnumRootEventBus.completedCircleAnim, () => this.setVisible(true));
  }
  setVisible(v: boolean){
    if(v){
      this.Angles[0].setVisible(true);
      this.Angles[1].setVisible(true);
      return
    }
    this.setAllVisible(v);
  }
  handleTriangleMode1(v: boolean){
      this.Triangle1Mode = v;
      v ? this.Triangle2Mode = false : "";
      this.checkVisibles();
  }
  handleTriangleMode2(v: boolean){
      this.Triangle2Mode = v;
      v ? this.Triangle1Mode = false : "";
      this.checkVisibles();
  }
  checkVisibles() {
    this.setAllVisible(false);
    let indexs = [0, 1];
    if (this.Triangle1Mode) indexs = [2, 3];
    else if (this.Triangle2Mode)  indexs = [0, 1, 4, 5, 6, 7];

    indexs.forEach(i => this.Angles[i].setVisible(true));
  }

  draw(points: Coord[], interSecPoint: Coord, clockwise: boolean = true) {
    const Points = generateAnglePoints(points, this.cCoord, interSecPoint, clockwise);

    Points.forEach((P, pI) => {
      const degree = pI < 2 ? 90 : calcAngle(P.curr, P.prev, P.next);
      this.drawAngle(this.Angles[pI], P, degree, P.clockwise);
    })
  }
}